var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("form", { attrs: { "data-vv-scope": "flow-part-1" } }, [
        _vm._m(0),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Nombre para el flujo (*)",
                  maxlength: "120",
                  name: "name",
                  danger: _vm.errors.has("flow-part-1.name"),
                  "danger-text": _vm.errors.first("flow-part-1.name")
                },
                model: {
                  value: _vm.step.name,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "name", $$v)
                  },
                  expression: "step.name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Descripción para el flujo (*)",
                  name: "description",
                  danger: _vm.errors.has("flow-part-1.description"),
                  "danger-text": _vm.errors.first("flow-part-1.description"),
                  maxlength: "550"
                },
                model: {
                  value: _vm.step.description,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "description", $$v)
                  },
                  expression: "step.description"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: _vm.step.executionType === "P" },
                    expression: "{ required: step.executionType === 'P' }"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Monto",
                  name: "amount",
                  type: "number",
                  danger: _vm.errors.has("flow-part-1.amount"),
                  "danger-text": _vm.errors.first("flow-part-1.amount")
                },
                model: {
                  value: _vm.step.amount,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "amount", $$v)
                  },
                  expression: "step.amount"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("UploadFile", {
                attrs: {
                  permission: "*",
                  accept: "application/pdf",
                  text: "Cargar Carátula",
                  "upload-to": "ed",
                  "button-class": {
                    "btn-block": true,
                    "mb-5": _vm.errors.has("flow-part-1.mainFileName")
                  },
                  "container-class": "w-100"
                },
                on: {
                  input: function($event) {
                    return _vm.addFile()
                  }
                },
                model: {
                  value: _vm.step.mainFile,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "mainFile", $$v)
                  },
                  expression: "step.mainFile"
                }
              }),
              _c("span", { staticClass: "text-danger" }, [
                _vm._v(" Sólo en formato PDF ")
              ])
            ],
            1
          ),
          Object.keys(_vm.step.mainFile).length
            ? _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-row align-items-center" },
                  [
                    _c("vs-icon", {
                      attrs: {
                        icon: "description",
                        size: "45px",
                        color: "primary"
                      }
                    }),
                    _c("b", { staticClass: "text-truncate w-100" }, [
                      _vm._v(_vm._s(_vm.step.mainFile.name))
                    ])
                  ],
                  1
                )
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          { staticClass: "row mb-3 mt-3" },
          [
            _c(
              "div",
              { staticClass: "col-md-3 d-flex align-items-end" },
              [
                _c("UploadFile", {
                  attrs: {
                    permission: "*",
                    text: "Cargar Archivos Adjuntos",
                    accept: "application/pdf",
                    "upload-to": "ed",
                    "button-class": "btn-block",
                    "container-class": "w-100"
                  },
                  on: {
                    input: function($event) {
                      return _vm.addAdditionalFile()
                    }
                  },
                  model: {
                    value: _vm.additionalFile,
                    callback: function($$v) {
                      _vm.additionalFile = $$v
                    },
                    expression: "additionalFile"
                  }
                })
              ],
              1
            ),
            _vm._l(_vm.step.attachments, function(file) {
              return _c("div", { key: file.id, staticClass: "col-3" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("vs-icon", {
                      attrs: {
                        icon: "description",
                        size: "45px",
                        color: "primary"
                      }
                    }),
                    _c(
                      "b",
                      { staticClass: "text-truncate w-100 text-center" },
                      [_vm._v(_vm._s(file.name))]
                    ),
                    _c("vs-button", {
                      attrs: { color: "danger", type: "flat", icon: "clear" },
                      on: {
                        click: function($event) {
                          return _vm.removeAdditionalFile(file.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            })
          ],
          2
        )
      ]),
      _c(
        "form",
        {
          attrs: { "data-vv-scope": "flow-part-2" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return (function() {
                return false
              })($event)
            }
          }
        },
        [
          _vm.step.executionType === "P"
            ? _c("div", { staticClass: "row mb-3 mt-4" }, [_vm._m(1)])
            : _vm._e(),
          _vm.searchingFlow
            ? _c("small", { staticClass: "text-primary" }, [
                _vm._v(
                  " Estamos buscando la información sobre el flujo que seleccionaste "
                )
              ])
            : _vm._e(),
          _vm.step.oldFlow && _vm.oldFlow.pasos
            ? _c("StepsOldFlow", { attrs: { steps: _vm.oldFlow.pasos } })
            : _vm._e(),
          !_vm.step.oldFlow
            ? _c("div", { staticClass: "row mt-4 mb-5" }, [
                _c(
                  "div",
                  { staticClass: "col-3 mt-3" },
                  [
                    _c(
                      "vs-select",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          autocomplete: "",
                          label: "Tipo de paso (*)",
                          name: "stepType",
                          "data-cy": "stepType",
                          danger: _vm.errors.has("flow-part-2.stepType"),
                          "danger-text": _vm.errors.first(
                            "flow-part-2.stepType"
                          )
                        },
                        on: { change: _vm.searchOffice },
                        model: {
                          value: _vm.stepType,
                          callback: function($$v) {
                            _vm.stepType = $$v
                          },
                          expression: "stepType"
                        }
                      },
                      [
                        _c("vs-select-item", {
                          attrs: { value: _vm.stepTypes.USER, text: "Usuario" }
                        }),
                        _c("vs-select-item", {
                          attrs: { value: _vm.stepTypes.GROUP, text: "Grupo" }
                        }),
                        _c("vs-select-item", {
                          attrs: {
                            value: _vm.stepTypes.OFFICE,
                            text: "Oficina"
                          }
                        }),
                        _c("vs-select-item", {
                          attrs: {
                            value: _vm.stepTypes.EXTERNAL,
                            text: "Externo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.stepType === _vm.stepTypes.GROUP
                  ? _c(
                      "div",
                      { staticClass: "col-6 mt-3" },
                      [
                        _c("list-groups", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: _vm.stepType === _vm.stepTypes.GROUP
                              },
                              expression:
                                "{ required: stepType === stepTypes.GROUP }"
                            }
                          ],
                          ref: "groupStep",
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "Grupo del responsable (*)",
                            name: "groupStep",
                            typeList: _vm.stepType,
                            danger: _vm.errors.has("flow-part-2.groupStep"),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.groupStep"
                            )
                          },
                          model: {
                            value: _vm.groupStep,
                            callback: function($$v) {
                              _vm.groupStep = $$v
                            },
                            expression: "groupStep"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.stepType === this.stepTypes.OFFICE
                  ? _c(
                      "div",
                      { staticClass: "col-6 mt-3" },
                      [
                        _c("list-offices", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: _vm.stepType === this.stepTypes.OFFICE
                              },
                              expression:
                                "{ required: stepType === this.stepTypes.OFFICE }"
                            }
                          ],
                          ref: "groupStep",
                          staticClass: "w-100 mb-1",
                          attrs: {
                            autocomplete: "",
                            label: "Oficina del responsable (*)",
                            name: "groupStep",
                            "data-vv-as": "oficina",
                            typeList: _vm.stepType,
                            "validate-lider": "",
                            withFilters: "",
                            officeType: "int",
                            danger: _vm.errors.has("flow-part-2.groupStep"),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.groupStep"
                            )
                          },
                          model: {
                            value: _vm.groupStep,
                            callback: function($$v) {
                              _vm.groupStep = $$v
                            },
                            expression: "groupStep"
                          }
                        }),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            " Si le falta una oficina, favor notificar al equipo de Soporte para que verifiquen que esté correctamente configurada "
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.stepType === _vm.stepTypes.USER
                  ? _c(
                      "div",
                      { staticClass: "col-6 mt-3" },
                      [
                        _c("list-user", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: _vm.stepType === _vm.stepTypes.USER
                              },
                              expression:
                                "{ required: stepType === stepTypes.USER }"
                            }
                          ],
                          ref: "userStep",
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "Usuario (*)",
                            name: "userStep",
                            danger: _vm.errors.has("flow-part-2.userStep"),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.userStep"
                            )
                          },
                          model: {
                            value: _vm.userStep,
                            callback: function($$v) {
                              _vm.userStep = $$v
                            },
                            expression: "userStep"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-4 mt-3" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required:
                                  _vm.stepType === _vm.stepTypes.EXTERNAL
                              },
                              expression:
                                "{ required: stepType === stepTypes.EXTERNAL }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Rut empresa o institución (*)",
                            name: "companyIut",
                            placeholder: "12345678-9",
                            autocomplete: "off",
                            danger: _vm.errors.has("flow-part-2.companyIut"),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.companyIut"
                            )
                          },
                          model: {
                            value: _vm.step.extern.iut,
                            callback: function($$v) {
                              _vm.$set(_vm.step.extern, "iut", $$v)
                            },
                            expression: "step.extern.iut"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-1 text-center mt-3" },
                      [
                        _c(
                          "b-overlay",
                          { attrs: { show: _vm.loadingCompany } },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Buscar empresa",
                                    expression: "'Buscar empresa'"
                                  }
                                ],
                                staticClass: "btn-icon rounded-circle p-3 mt-5",
                                attrs: { variant: "primary", size: "sm" },
                                on: {
                                  click: function($event) {
                                    return _vm.searchCompanyIut()
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "SearchIcon" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.externCompany.iut && _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-4 mt-3" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required:
                                  _vm.stepType === _vm.stepTypes.EXTERNAL
                              },
                              expression:
                                "{ required: stepType === stepTypes.EXTERNAL }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Razón empresa (*)",
                            name: "razonSocial",
                            danger: _vm.errors.has("flow-part-2.razonSocial"),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.razonSocial"
                            )
                          },
                          model: {
                            value: _vm.externCompany.razonSocial,
                            callback: function($$v) {
                              _vm.$set(_vm.externCompany, "razonSocial", $$v)
                            },
                            expression: "externCompany.razonSocial"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.externCompany.iut &&
                !_vm.newCompany &&
                  _vm.externCompany.users &&
                  _vm.externCompany.users.length &&
                _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c("div", { staticClass: "col-4 mt-3" }, [
                      _c(
                        "div",
                        [
                          _vm._v(" Posibles firmantes "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Ver usuarios de la empresa",
                                  expression: "'Ver usuarios de la empresa'"
                                },
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal",
                                  value: "users-extern-company",
                                  expression: "'users-extern-company'"
                                }
                              ],
                              staticClass: "btn-icon rounded-circle p-3 mt-5",
                              attrs: { variant: "secondary", size: "sm" }
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "UsersIcon" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm.externCompany.iut && _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-4 mt-3" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required:
                                  _vm.stepType === _vm.stepTypes.EXTERNAL
                              },
                              expression:
                                "{ required: stepType === stepTypes.EXTERNAL }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Rut del firmante (*)",
                            name: "responsibleIut",
                            danger: _vm.errors.has(
                              "flow-part-2.responsibleIut"
                            ),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.responsibleIut"
                            )
                          },
                          model: {
                            value: _vm.step.extern.responsibleIut,
                            callback: function($$v) {
                              _vm.$set(_vm.step.extern, "responsibleIut", $$v)
                            },
                            expression: "step.extern.responsibleIut"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.externCompany.iut && _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-4 mt-3" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required:
                                  _vm.stepType === _vm.stepTypes.EXTERNAL
                              },
                              expression:
                                "{ required: stepType === stepTypes.EXTERNAL }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Nombre del firmante (*)",
                            name: "responsibleName",
                            danger: _vm.errors.has(
                              "flow-part-2.responsibleName"
                            ),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.responsibleName"
                            )
                          },
                          model: {
                            value: _vm.step.extern.responsibleName,
                            callback: function($$v) {
                              _vm.$set(_vm.step.extern, "responsibleName", $$v)
                            },
                            expression: "step.extern.responsibleName"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.externCompany.iut && _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-4 mt-3" },
                      [
                        _c("vs-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required:
                                  _vm.stepType === _vm.stepTypes.EXTERNAL
                              },
                              expression:
                                "{ required: stepType === stepTypes.EXTERNAL }"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Correo del firmante (*)",
                            name: "responsibleEmail",
                            danger: _vm.errors.has(
                              "flow-part-2.responsibleEmail"
                            ),
                            "danger-text": _vm.errors.first(
                              "flow-part-2.responsibleEmail"
                            )
                          },
                          model: {
                            value: _vm.step.extern.responsibleEmail,
                            callback: function($$v) {
                              _vm.$set(_vm.step.extern, "responsibleEmail", $$v)
                            },
                            expression: "step.extern.responsibleEmail"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.stepType === _vm.stepTypes.EXTERNAL
                  ? _c("div", { staticClass: "col-4 mt-3 text-primary" }, [
                      _vm._m(2)
                    ])
                  : _vm._e(),
                _vm.stepType !== _vm.stepTypes.OFFICE &&
                _vm.stepType !== _vm.stepTypes.EXTERNAL
                  ? _c(
                      "div",
                      { staticClass: "col-3 mt-3" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Tipo de rol (*)" } },
                          [
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                danger: _vm.errors.has("flow-part-2.rolType")
                              },
                              attrs: {
                                id: "rolType",
                                label: "label",
                                options: _vm.rolTypesOption,
                                reduce: function(rol) {
                                  return rol.id
                                },
                                name: "rolType"
                              },
                              model: {
                                value: _vm.rolType,
                                callback: function($$v) {
                                  _vm.rolType = $$v
                                },
                                expression: "rolType"
                              }
                            }),
                            _c("InfoRolType"),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "flow-part-2.rolType"
                                    ),
                                    expression:
                                      "errors.has('flow-part-2.rolType')"
                                  }
                                ],
                                staticClass:
                                  "danger span-text-validation-danger v-enter-to"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("flow-part-2.rolType")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.stepType === _vm.stepTypes.OFFICE
                  ? _c(
                      "div",
                      { staticClass: "col-3 mt-3" },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Tipo de rol (*)" } },
                          [
                            _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                danger: _vm.errors.has("flow-part-2.rolType")
                              },
                              attrs: {
                                label: "label",
                                options: _vm.rolTypesOfficeOption,
                                reduce: function(rol) {
                                  return rol.id
                                },
                                name: "rolType"
                              },
                              model: {
                                value: _vm.rolType,
                                callback: function($$v) {
                                  _vm.rolType = $$v
                                },
                                expression: "rolType"
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _vm._v(" info "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn-icon rounded-circle mt-1",
                                    attrs: {
                                      size: "sm",
                                      id: "popover-button",
                                      variant: "flat-primary"
                                    }
                                  },
                                  [
                                    _c("feather-icon", {
                                      attrs: { icon: "InfoIcon" }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-popover",
                                  {
                                    attrs: {
                                      target: "popover-button",
                                      triggers: "focus",
                                      placement: "top"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function() {
                                            return [
                                              _c("span", [
                                                _vm._v("Tipos de roles!")
                                              ])
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      2187985360
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _c("b", [_vm._v("+ Numerar/tramitar:")]),
                                      _vm._v(
                                        " Permite firmar documentos, esto cuenta como la aprobación, se coloca un estampado de numeración o trámite. "
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "flow-part-2.rolType"
                                    ),
                                    expression:
                                      "errors.has('flow-part-2.rolType')"
                                  }
                                ],
                                staticClass:
                                  "danger span-text-validation-danger v-enter-to"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("flow-part-2.rolType")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          !_vm.step.oldFlow
            ? _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 d-flex align-items-end justify-content-end"
                  },
                  [
                    _c(
                      "vs-button",
                      {
                        attrs: {
                          color: "primary",
                          icon: "add",
                          disabled: _vm.blockButton,
                          "data-cy": "add-step"
                        },
                        on: {
                          click: function($event) {
                            return _vm.addStep()
                          }
                        }
                      },
                      [_vm._v(" Agregar Paso ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _c("StepsFlow", {
            attrs: { steps: _vm.step.steps },
            on: { "remove-step": _vm.removeStep }
          }),
          _vm.error.message !== ""
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                  staticStyle: { height: "32px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.error.message) + " ")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "usersExternCompany",
          attrs: {
            id: "users-extern-company",
            title: "Usuarios de la empresa " + _vm.externCompany.iut,
            "cancel-title": "Cancelar",
            size: "lg"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { height: "500px", overflow: "scroll" } },
            [
              _c("h5", [_vm._v("Estos usuarios ya existen en la empresa")]),
              _vm._l(_vm.externCompany.users, function(user) {
                return _c(
                  "div",
                  {
                    key: user.id,
                    staticClass:
                      "employee-task mb-2 d-flex justify-content-between align-items-center step-box",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function($event) {
                        return _vm.selectUser(user)
                      }
                    }
                  },
                  [
                    _c(
                      "b-media",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-media-aside",
                          { staticClass: "mr-75" },
                          [
                            user.id
                              ? _c("b-avatar", {
                                  staticClass: "mt-25 mr-75",
                                  attrs: {
                                    rounded: "",
                                    text: _vm._f("avatarName")(user.nombre),
                                    size: "42"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("b-media-body", { staticClass: "my-auto" }, [
                          _c("h5", { staticClass: "mb-0" }, [
                            _vm._v(" " + _vm._s(user.nombre) + " ")
                          ])
                        ])
                      ],
                      1
                    ),
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("small", { staticClass: "text-muted mr-75" }, [
                        _vm._v(" " + _vm._s(user.correo) + " ")
                      ])
                    ])
                  ],
                  1
                )
              })
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Datos para el flujo del Estado de Pago")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Detalle del flujo")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("- Este tipo de paso será "),
        _c("b", [_vm._v("firmante")])
      ]),
      _c("li", [
        _vm._v("- Este tipo de firma será "),
        _c("b", [_vm._v("firma avanzada")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }